import { useEffect } from "react";
import { useLocation } from "react-router";
import { selectWsSportDisabled } from "@nxplatform/platform-settings/locale-setup.routes";
import { getBetRadarSportDataSuccess } from "@nxplatform/store-shared/sport/shared-sport-actions";
import { publicEventsIds } from "@service/api-client/websockets/centrifuge";
const useSportsData = ({
  isTextPage,
  clearState,
  addPublicWsChannels,
  removePublicWsChannels,
  publicWsAliveChannels
}) => {
  const { pathname } = useLocation();
  useEffect(() => {
    return () => {
      clearState();
      removePublicWsChannels(publicEventsIds);
    };
  }, []);
  useEffect(() => {
    const disabledSportWsChannels = selectWsSportDisabled(pathname);
    if (disabledSportWsChannels) {
      removePublicWsChannels(publicEventsIds);
      return;
    }
    const hasConnected = publicEventsIds.every((el) => publicWsAliveChannels.includes(el));
    if (disabledSportWsChannels || hasConnected || isTextPage) return;
    addPublicWsChannels({ channels: publicEventsIds, handler: getBetRadarSportDataSuccess });
  }, [pathname, isTextPage, JSON.stringify(publicWsAliveChannels)]);
};
export {
  useSportsData
};
